// extracted by mini-css-extract-plugin
export var typingIndicator = "_kb-0";